module.exports = __webpack_public_path__ + "static/media/cancel.c4a04ae8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/cancel.svg
// module id = 80
// module chunks = 0